import { projectsApi } from 'api'

export interface Props {
  email: string
  persistentPlatformFile?: { id: string } | null
}

export const updateUser = ({ email, persistentPlatformFile }: Props) =>
  projectsApi.patch<{ data: any }>('/users/me', {
    email,
    persistentPlatformFile,
  })
